<template>
  <div class="post-content-data__chart">
    <script
      type="application/javascript"
      :id="data.id"
      title="Oxfam Brasil - Carga tributária, Brasil versus países da OCDE - 2015"
      src="https://e.infogram.com/js/dist/embed.js?SGO"
    ></script>
    <div style="padding:8px 0;font-family:Arial!important;font-size:13px!important;line-height:15px!important;text-align:center;border-top:1px solid #dadada;margin:0 30px">
      <a :href="data.link" style="color:#989898!important;text-decoration:none!important;" target="_blank">{{data.title}}</a>
      <br>
      <a href="https://infogram.com" style="color:#989898!important;text-decoration:none!important;" target="_blank" rel="nofollow">Infogram</a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
};
</script>

<style lang="scss">
.post-content-data__chart {
  grid-column-start: 2;
}
</style>
